import React from "react";
import { Modal, Box, Typography, Divider, Button as MUIButton } from "@mui/material";
import { colors } from "../../../utils/theme.js";

const ErrorModal = ({ open, handleClose, handleRetry }) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "50vw",
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: "8px",
          p: 4,
        }}
      >
        <Typography
          sx={{
            fontWeight: "700",
            my: "1rem",
            color: "#232323",
            fontSize: "24px",
            lineHeight: "43px",
            fontFamily: "DM Sans",
          }}
          textAlign="center"
        >
          Oops! Something Went Wrong
        </Typography>
        <Divider sx={{ backgroundColor: "#E1E1E1", height: "2px" }} />
        <Typography
          sx={{
            fontWeight: "500",
            mt: "1rem",
            mb: "3rem",
            color: "#123051",
            fontSize: "14px",
            lineHeight: "20px",
            fontFamily: "DM Sans",
          }}
          textAlign="center"
        >
          We're experiencing technical difficulties, and our servers are currently down.
          <br /> Please try again later.
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "50%",
            margin: "auto",
          }}
        >
          <MUIButton
            sx={{
              mx: "1rem",
              borderStyle: "solid",
              borderWidth: "1px",
              borderColor: colors.PrimaryPurple,
              color: colors.PrimaryPurple,
            }}
            onClick={handleClose}
          >
            Go Back
          </MUIButton>
          <MUIButton
            sx={{
              color: colors.white,
              backgroundColor: colors.PrimaryPurple,
            }}
            onClick={handleRetry}
          >
            Retry
          </MUIButton>
        </Box>
      </Box>
    </Modal>
  );
};

export default ErrorModal;